// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags-list{-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;height:100%;-webkit-columns:2;-moz-columns:2;columns:2;font-size:35px;text-align:left;width:100%}.tags-list--tag{cursor:pointer;margin:20px 10px;padding:10px;display:block}.tags-list--tag-index{width:1.25em;display:inline-block}", ""]);
// Exports
module.exports = exports;
